module.exports = __webpack_public_path__ + "img/UpSellInActive.087eb0ee.svg";